<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">
      {{ $t("viewRoles.title") }}
      <v-btn
        color="success"
        class="ml-1 green-shadow"
        x-small
        fab
        :loading="!fetched"
        max-width="26"
        max-height="26"
        :title="$t('common.add')"
        :to="{ name: 'user-role-create' }"
      >
        <v-icon x-small>$plus</v-icon>
      </v-btn>
    </h3>

    <v-data-table
      :headers="usersTableHeader"
      :items="roles"
      class="mb-3"
      elevation="0"
      :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item="props">
        <tr>
          <td class="text-xs-left">
            {{
              props.item.type === "system"
                ? $t("common.systemRolesNames." + props.item.name)
                : props.item.name
            }}
          </td>
          <td class="text-right">
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              color="primary"
              class="mb-0 ml-3 px-0 white--text"
              :to="{ name: 'user-role', params: { id: props.item.id } }"
              :title="$t('common.edit')"
            >
              <v-icon small>$pencil</v-icon>
            </v-btn>
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              @click="$store.dispatch('roles/remove', { id: props.item.id })"
              color="red lighten-2"
              class="mb-0 ml-3 px-0 white--text"
              :title="$t('common.remove')"
              :disabled="props.item.id < 0"
            >
              <v-icon small>$trash</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  data: () => ({}),
  mounted() {
    this.$store.dispatch("roles/get").then(() => {});
  },
  computed: {
    ...mapFields("roles", ["roles", "fetched"]),
    usersTableHeader() {
      return [
        {
          text: this.$t("viewUsers.usersTableHeader.Name"),
          value: "name",
          sortable: true,
        },
        { text: this.$t("common.actions"), sortable: false, align: "right" },
      ];
    },
  },
  methods: {
    extraRightsColors(value) {
      let color;
      switch (value) {
        case 0:
          color = "blue-grey";
          break;

        case 1:
          color = "light-blue accent-2";
          break;

        case 2:
          color = "green";
          break;
      }
      return color;
    },
    extraRightsSymbol(value) {
      let color;
      switch (value) {
        case 0:
          color = "fa-ban";
          break;

        case 1:
          color = "fa-eye";
          break;

        case 2:
          color = "fa-edit";
          break;
      }
      return color;
    },
  },
};
</script>
